import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '../components/common/components/button/button.component';

@Component({
  selector: 'app-remove-favorite',
  standalone: true,
  imports: [MatDialogModule, CommonModule, FormsModule, ButtonComponent],
  templateUrl: './remove-favorite.component.html',
  styleUrl: './remove-favorite.component.scss'
})
export class RemoveFavoriteComponent {
  title: string = "";
  promId: number = 0;
  actionType: string = "";
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<RemoveFavoriteComponent>, private dialog: MatDialog) {
    if (data) {
      this.title = data.title
      this.promId = data.promId
      this.actionType = data.actionType
    }
  }

  onClose(event: any): void {
    this.dialogRef.close(true);
  }

  onSubmit(event: Event) {
    let request = {
      "prompt_id": this.promId,
      "action_type": this.actionType,
      "event": event,
      "remove_fav": true
    }
    this.dialogRef.close(request);
  }
}
